{
  "modelPortfolioTable": {
    "name": "Nom du modèle",
    "newModelName": "Nouveau nom de modèle",
    "newModelNameBottomLabel": "Vous pourrez y apporter des modifications plus tard dans les détails du modèle.",
    "theme": "Groupe",
    "description": "Description du modèle",
    "tag": "Balise",
    "type": "Type",
    "#OfAccounts": "Nombre de comptes",
    "#OfPortfolios": "Nombre de portefeuilles",
    "assetClass": "Catégorie d'actifs",
    "status": "Statut",
    "valueAssigned": "Valeur assignée",
    "filterModal": {
      "none": "Aucun",
      "modalTitle": "Filtrer les portefeuilles modèles",
      "groupTitle": "Groupe"
    },
    "createModel": "Créer un nouveau modèle",
    "createTheme": "Créer un nouveau groupe",
    "modelFamily": "Famille de modèles",
    "totalCount": "Nombre",
    "actions": {
      "clone": "Cloner le modèle",
      "edit": "Modifier le modèle",
      "activate": "Activer le modèle",
      "draft": "Déplacer dans les brouillons",
      "archive": "Déplacer dans les archives"
    },
    "error": {
      "transitionModelPortfolio": "Impossible d'effectuer la transition du portefeuille de modèle"
    },
    "archive": {
      "disabledTooltip": "Impossible d'archiver : actuellement attribué(s) à {{count}} sous-compte(s) ou objectif(s).",
      "disabledTooltipUnknown": "Impossible d'archiver : l'utilisation n'a pas pu être chargée. Essayez d'actualiser."
    }
  },
  "createModelPortfolio": {
    "name": "Nom du modèle",
    "description": "Description du modèle",
    "type": "Type de modèle",
    "FROM_SCRATCH": "À partir de zéro",
    "FROM_TEMPLATE": "À partir d'un modèle",
    "label": "Créer un portefeuille de modèles",
    "driftCalculationMethodLabel": "Méthode de calcul de la dérive",
    "driftTolerancePercentLabel": "Tolérance de dérive",
    "driftToleranceRangeError": "Entrez un nombre entier entre 5 et 20, ou laissez vide pour hériter.",
    "driftSettingsTooltip": "Jusqu'où un portefeuille peut s'écarter de sa cible avant qu'un rééquilibrage ne soit signalé. Laissez vide pour hériter de la valeur par défaut de l'organisation. Les bandes absolues sont plafonnées à 0 % et 100 %. Une cible de 5 % avec une bande de 10 % déclenche donc entre 0 % et 15 %.",
    "driftToleranceHint": "Entrez un nombre entier entre 5 et 20 %, ou laissez vide pour hériter",
    "driftInheritedUnknown": "Hérité",
    "driftInherited": "{{method}} (Hérité)"
  },
  "strategy": {
    "label": "Stratégie du modèle",
    "STANDARD": "Standard",
    "ASSET_CLASS": "Regroupé par classe d'actifs"
  },
  "assetClassIPSDisclaimer": "Ces valeurs sont fournies à titre informatif uniquement",
  "assetClassLevel": "Niveau de classe d'actifs",
  "assetClassLevelPlaceholder": "Sélectionner le niveau de classe d'actifs",
  "PRIMARY": "Classe d'actifs primaire",
  "SECONDARY": "Classe d'actifs secondaire",
  "TERTIARY": "Classe d'actifs tertiaire",
  "autoTarget": "Cible automatique",
  "unassigned": "Non attribué",
  "withinGroupPercent": "% du groupe",
  "riskProfile": {
    "CONSERVATIVE": "Conservateur",
    "MODERATELY_CONSERVATIVE": "Modérément conservateur",
    "MODERATE": "Modéré",
    "GROWTH": "Croissance",
    "AGGRESSIVE": "Agressif",
    "VERY_AGGRESSIVE": "Très agressif"
  },
  "addSecurity": "+ Ajouter une valeur mobilière",
  "addCash": "+ Ajouter des liquidités",
  "cashEquivalentSecurity": "Valeur mobilière en équivalent de trésorerie",
  "createNewTemplate": "Créer un nouveau modèle",
  "selectTemplate": "Sélectionner un modèle",
  "templateName": "Nom du modèle",
  "templateDescription": "Description du modèle",
  "createAndUseTemplate": "Créer et utiliser un modèle",
  "addAssetClassBranch": "+ Ajouter",
  "min": "Min",
  "max": "Max",
  "actualPercentage": "% réel",
  "assetClasses": "Catégories d'actifs",
  "assetClass": "Catégorie d'actifs",
  "assetAllocation": "Allocation d'actifs",
  "portfolioDetails": {
    "details": {
      "fundamentalDetailsLink": "Lien vers les détails fondamentaux",
      "zeroPercentCash": "0 % de trésorerie",
      "riskProfile": "Profil de risque"
    }
  },
  "remove": "Retirer",
  "cashEquivalent": "Équivalent en espèces",
  "portfolio": {
    "tabs": {
      "assetAllocation": "Allocation d'actifs",
      "details": "Détails",
      "invPolicyStatement": "Énoncé de la politique de placement",
      "auditLog": "Rapport d'activité"
    },
    "edit": {
      "save": "Enregistrer",
      "cancel": "Annuler"
    },
    "details": {
      "genDetails": "Détails généraux",
      "name": "Nom",
      "suggestable": "Suggérable",
      "modelFamily": "Famille de modèles",
      "url": "URL",
      "riskReturn": "Risque et retour",
      "lowThresholdScore": "Score seuil minimal",
      "minScore": "Score minimum",
      "maxScore": "Score maximum",
      "riskReturnLevel": "Niveau risque/rendement",
      "forecastRateReturn": "Taux de rendement prévu",
      "forecastStandardDeviation": "Écart-type prévu",
      "riskProfileName": "Nom du profil de risque",
      "riskProfileDescription": "Description du profil de risque",
      "suggest": {
        "yes": "Oui",
        "no": "Non"
      }
    },
    "policyAndAssets": {
      "description": "Description",
      "investmentObjective": "Objectif de placement",
      "liquidity": "Liquidité",
      "disclaimer": "Avis de non-responsabilité",
      "assetAllocation": "Allocation d'actifs"
    },
    "noAccess": "Vous n'avez pas d'accès en lecture. Veuillez communiquer avec votre administrateur.",
    "success": "Portefeuille de modèles correctement mis à jour",
    "createActiveSuccess": "Portefeuille de modèles actif créé avec succès.",
    "draftSaveSuccess": "Brouillon du portefeuille de modèles enregistré avec succès.",
    "saveError": "Échec de l'enregistrement du portefeuille de modèles",
    "missingAssetClassLevel": "Veuillez sélectionner un niveau de classe d'actifs avant d'enregistrer un portefeuille groupé par classe d'actifs.",
    "error": "Impossible de mettre à jour le portefeuille de modèle",
    "exceedsTotalAllocation": "Dépasse l'allocation totale",
    "totalAllocationError": "Le total actuel de {{totalPercentage}} dépasse l'allocation maximale autorisée. Veuillez ajuster l'allocation cible pour atteindre le total de {{maxPercentage}}",
    "ok": "OK",
    "noSecuritiesUrl": "Aucune valeur mobilière trouvée",
    "securitiesOrderedByTaxRank": "Les valeurs mobilières sont classées par rang d'imposition. Pour les modifier, vous pouvez les faire glisser et les déposer ou les mettre à jour manuellement.",
    "zeroPercentError": "Les titres avec une allocation de 0 % ne sont pas autorisés.",
    "noFinancialProductError": "Les titres sans produit financier ne sont pas autorisés.",
    "noPercentageError": "Les titres sans pourcentage ne sont pas autorisés.",
    "invalidPrimaryAssetClass": "Les titres sans classe d'actifs principale ne sont pas autorisés.",
    "noSecurityError": "Aucune valeur mobilière trouvée",
    "incompleteAllocationError": "Les allocations de classes d'actifs doivent totaliser exactement 100 % avant de pouvoir continuer.",
    "unassignedSecuritiesError": "Tous les titres doivent appartenir à un groupe de classes d'actifs.",
    "groupAllocationError": "Chaque groupe de classes d'actifs doit avoir au moins un titre et ses allocations doivent totaliser exactement 100 %.",
    "duplicateTaxRankError": "Les rangs fiscaux en double ne sont pas autorisés. Veuillez vous assurer que chaque titre a un rang fiscal unique.",
    "taxRankGapsError": "Les rangs fiscaux doivent commencer à 1 et ne pas avoir de lacunes. Veuillez vous assurer que les rangs forment une séquence consécutive à partir de 1.",
    "strategyChangedSecuritiesCleared": "Le changement de stratégie a effacé la liste des valeurs mobilières.",
    "updateError": "Échec de la mise à jour du portefeuille de modèles",
    "createError": "Échec de la création du portefeuille de modèles"
  },
  "templateDoesntMatch": {
    "title": "Le modèle ne correspond pas",
    "body": "Le modèle que vous avez créé n'est pas en phase avec le modèle utilisé. Voulez-vous continuer?"
  },
  "exportHeaders": {
    "securityId": "Identifiant de la valeur mobilière",
    "isCashEquivalent": "Est équivalent en espèces",
    "financialProductId": "Produit financier - Identifiant",
    "primaryAssetClassId": "Catégorie d'actifs primaires - Identifiant",
    "primaryAssetClassName": "Catégorie d'actifs primaires - Nom",
    "secondaryAssetClassId": "Catégorie d'actifs secondaires - Identifiant",
    "secondaryAssetClassName": "Catégorie d'actifs secondaires - Nom",
    "financialProductIsCash": "Produit financier - Liquidités",
    "financialProductTaxRank": "Produit financier - Rang fiscal",
    "financialProductTicker": "Produit financier - Symbole",
    "financialProductName": "Produit financier - Nom"
  },
  "exportConfig": {
    "progressTitle": "Exportation des valeurs mobilières du portefeuille de modèles"
  },
  "success": {
    "cloneModelPortfolio": "Portefeuille de modèles correctement cloné"
  },
  "copyOfPrefix": "Copie de {{name}}",
  "clearFilter": "Effacer le filtre",
  "importCsv": {
    "title": "Importer CSV?",
    "description": "Si vous avez déjà créé un modèle dans Excel, vous pouvez choisir de l'importer en cliquant sur l'icône de téléchargement juste au-dessus du graphique, ou en faisant glisser et déposer le fichier directement sur le tableau des titres.",
    "modalTitle": "Importer un fichier CSV",
    "modalDescription": "Importez un fichier CSV pour ajouter rapidement des titres à votre portefeuille. Veuillez vous assurer que votre CSV inclut les colonnes suivantes : Security Identifier (Ticker), Pondération cible %, Tax Rank (optional).",
    "import": "Importer le fichier",
    "uploadTooltip": "Télécharger le fichier CSV",
    "downloadTemplate": "Télécharger le modèle",
    "successMessage": "Titres importés avec succès",
    "errorMessage": "Échec de l'importation des titres",
    "reviewTitle": "Réviser les titres",
    "reviewDescription": "Les titres suivants ne sont pas disponibles. Remplacez-les par des liquidités ou un autre titre pour continuer.",
    "progress": {
      "parsing": "Analyse du fichier CSV...",
      "validatingData": "Validation des données CSV...",
      "extractingSecurities": "Extraction des titres...",
      "fetchingSecurities": "Récupération des titres...",
      "processingSecuritiesData": "Traitement des données de titres...",
      "validatingRows": "Validation des lignes CSV...",
      "fetchingReplacementSecurities": "Récupération de tous les titres disponibles pour le remplacement...",
      "finalizing": "Finalisation de l'importation...",
      "complete": "Importation terminée"
    },
    "errors": {
      "totalAllocation": "L'allocation totale doit être égale à {{total}}% (actuellement {{current}}%)",
      "selectReplacements": "Veuillez sélectionner des remplacements pour : {{tickers}}",
      "rowMissingIdentifier": "Ligne {{rowNumber}} : identifiant du titre manquant",
      "invalidTargetWeight": "Ligne {{rowNumber}} (Symbole : {{ticker}}) : pondération cible \"{{targetWeight}}\" invalide (doit être entre {{min}}-{{max}})",
      "invalidTaxRank": "Ligne {{rowNumber}} (Symbole : {{ticker}}) : rang fiscal \"{{taxRank}}\" invalide (doit être >= {{min}})",
      "duplicateTaxRanks": "Des rangs fiscaux dupliqués ont été trouvés dans le CSV. Chaque rang fiscal fourni doit être unique.",
      "failedToImportPrefix": "Échec de l'importation CSV :",
      "moreErrorsOne": "... et {{count}} erreur supplémentaire",
      "moreErrorsMany": "... et {{count}} erreurs supplémentaires",
      "emptyFile": "Le fichier CSV est vide",
      "fileTooLarge": "La taille du fichier ({{fileSize}}MB) dépasse la taille maximale autorisée de {{maxSize}}MB. Veuillez utiliser un fichier plus petit.",
      "failedToParse": "Échec de l'analyse du CSV : {{reason}}",
      "maxRowsExceeded": "Le CSV dépasse le nombre maximal de lignes autorisées ({{maxRows}}). Au moins {{rowsProcessed}} lignes ont été trouvées.",
      "noData": "Aucune donnée trouvée dans le fichier CSV"
    }
  },
  "securityTableColumns": {
    "security": "Titre",
    "assetClass": "Classe d'actifs",
    "taxRank": "Rang fiscal",
    "targetPercentage": "Cible %",
    "portfolioPercentage": "Portefeuille %"
  },
  "modelName": "Portefeuille modèle",
  "drift": {
    "sectionLabel": "Paramètres de dérive",
    "confirmTitle": "Recalculer les détenteurs de ce portefeuille modèle?",
    "confirmBody": "Cela recalculera tous les détenteurs de ce portefeuille modèle. Les paramètres de dérive resteront verrouillés jusqu'à ce que le processus soit terminé.",
    "confirmApply": "Appliquer",
    "reviewRebalanceReport": "Consultez le rapport de rééquilibrage pour les portefeuilles qui dépassent maintenant leurs allocations cibles.",
    "recalculationComplete": "Recalcul terminé pour {{name}}.",
    "activeModelTradesNotice": "Cette mise à jour n'affectera aucune transaction en cours de traitement — si des transactions sont déjà en cours, le modèle pourrait ou non retrouver son équilibre une fois qu'elles seront réglées."
  },
  "securityTablePercentageInfoTitle": "Cible % et Portefeuille %",
  "securityTablePercentageInfo": "**Cible %** — Allocation des fonds au sein de son groupe de classes d'actifs. Chaque groupe doit totaliser 100 %.\n\n**Portefeuille %** — Allocation des fonds dans l'ensemble du portefeuille modèle. Tous les fonds totalisent 100 %.",
  "securityTablePortfolioPercentageInfo": "Pondération totale (% intra-classe × % du groupe)",
  "securityTablePortfolioPercentageInfoAria": "Aide pour la colonne pourcentage du portefeuille"
}
